import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Tabs from '../../../../common/base/Tabs';
import CopyableField from '../../../../common/CopyableField';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Badge from '../../../../common/base/Badge';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import Link from '../../../../common/base/Link';
import Button from '../../../../common/base/Button';
interface Props {
  nextStep: () => void;
}
const platforms = {
  npm: {
    label: 'NPM',
    command: 'npm install hookdeck-cli -g'
  },
  yarn: {
    label: 'Yarn',
    command: 'yarn global add hookdeck-cli'
  },
  homebrew: {
    label: 'Homebrew',
    command: 'brew install hookdeck'
  },
  windows: {
    label: 'Windows',
    commands: ['scoop bucket add hookdeck https://github.com/hookdeck/scoop-hookdeck-cli.git', 'scoop install hookdeck']
  },
  linux: {
    label: 'Linux',
    commands: [<Div key="download" flex={{
      align: 'center',
      gap: 1
    }}>
        <Text base>Download the latest release’s</Text>
        <Link href="https://github.com/hookdeck/hookdeck-cli/releases/latest" target="_blank" onClick={e => e.stopPropagation()}>
          <Text base semi>
            tar.gz file
          </Text>
        </Link>
      </Div>, 'tar -xvf hookdeck_X.X.X_linux_x86_64.tar.gz', './hookdeck']
  }
};
type PlatformKey = keyof typeof platforms;
const InstallCLI: React.FC<Props> = t0 => {
  const $ = _c(16);
  const {
    nextStep
  } = t0;
  const [active_tab, setActiveTab] = useState("npm");
  const current_platform = platforms[active_tab];
  const commands = "commands" in current_platform ? current_platform.commands : current_platform.command;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.entries(platforms).map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = key_0 => setActiveTab(key_0 as PlatformKey);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      t: 2,
      x: 3
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== active_tab) {
    t4 = <StyledCardSection><Tabs tabs={t1} active_tab={active_tab} onTabSelected={t2} compact={true} border={false} m={t3} /></StyledCardSection>;
    $[3] = active_tab;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== commands) {
    t5 = <StyledCardSection>{Array.isArray(commands) ? <Div p={2} flex={{
        direction: "column",
        gap: 2
      }}>{commands.map(_temp2)}</Div> : <CopyableField borderless={true} m={0} p={{
        x: 3,
        y: 3
      }} value={commands} mono={true} variant="command_list" />}</StyledCardSection>;
    $[5] = commands;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <StyledCard overflow_hidden={true}>{t4}{t5}</StyledCard>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      t: 6
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== nextStep) {
    t8 = <Div m={t7}><Button outline={true} onClick={() => nextStep()}>Next</Button></Div>;
    $[11] = nextStep;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <Div>{t6}{t8}</Div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default InstallCLI;
function _temp(t0) {
  const [key, platform] = t0;
  return {
    key,
    label: platform.label
  };
}
function _temp2(command, i) {
  return <CopyableField key={command.toString()} m={0} p={{
    x: 3,
    y: 3
  }} value={command.toString()} wrap={true} variant="command_list" valueElement={<Div flex={{
    align: "center",
    gap: 2
  }}><Badge neutral={true} style={{
      flexShrink: 0
    }}>{i + 1}</Badge><Text mono={true} text_wrap={false} word_break="break-all" white_space="pre-wrap" align="left" style={{
      minWidth: 0
    }} title={command.toString()}>{command}</Text></Div>} mono={true} />;
}